import React from 'react';
import { X, Share } from 'lucide-react';

interface IOSInstallModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const IOSInstallModal: React.FC<IOSInstallModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[100] flex items-end sm:items-center justify-center p-0 sm:p-4"
      onClick={onClose}
    >
      <div
        className="bg-theme-cards rounded-t-3xl sm:rounded-2xl max-w-md w-full border border-white/10 shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-6">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-xl font-bold text-white">Install VybeTribe</h2>
            <button
              onClick={onClose}
              className="text-theme-text-secondary hover:text-white transition-colors"
              aria-label="Close"
            >
              <X size={24} />
            </button>
          </div>

          <div className="space-y-4">
            <p className="text-theme-text-secondary">
              Install VybeTribe on your iPhone for quick access and a better experience.
            </p>

            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-gradient-to-r from-pink-500 to-cyan-500 flex items-center justify-center text-white font-semibold text-sm">
                  1
                </div>
                <div className="flex-1">
                  <p className="text-white">
                    Tap the <Share size={16} className="inline mx-1" /> <strong>Share</strong> button at the bottom of Safari
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-gradient-to-r from-pink-500 to-cyan-500 flex items-center justify-center text-white font-semibold text-sm">
                  2
                </div>
                <div className="flex-1">
                  <p className="text-white">
                    Scroll down and tap <strong>"Add to Home Screen"</strong>
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-gradient-to-r from-pink-500 to-cyan-500 flex items-center justify-center text-white font-semibold text-sm">
                  3
                </div>
                <div className="flex-1">
                  <p className="text-white">
                    Tap <strong>"Add"</strong> to complete the installation
                  </p>
                </div>
              </div>
            </div>

            <button
              onClick={onClose}
              className="w-full bg-gradient-to-r from-red-500 to-pink-600 hover:from-red-600 hover:to-pink-700 text-white px-6 py-3 rounded-full font-semibold transition-all shadow-lg"
            >
              Got it
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IOSInstallModal;
